import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useEffect } from 'react';
import { Box, Container, Grid, TAGSvgIcon, useTheme } from '../../';
import RichText from './RichText';
import { ASPENDENTAL_FONTS } from '../../constants/constant';
var BACKGROUND_COLORS;

(function (BACKGROUND_COLORS) {
  BACKGROUND_COLORS["green"] = "green";
  BACKGROUND_COLORS["blue"] = "blue";
})(BACKGROUND_COLORS || (BACKGROUND_COLORS = {}));

var AlertBanner = function AlertBanner(_ref) {
  var _BANNER_COLORS;

  var alerts = _ref.alerts,
      branding = _ref.branding;
  var theme = useTheme();

  var _useState = useState(alerts.length ? {
    display: 'block',
    clicked: false
  } : {
    display: 'none',
    clicked: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      visibility = _useState2[0],
      setVisibility = _useState2[1];

  var BANNER_COLORS = (_BANNER_COLORS = {}, _defineProperty(_BANNER_COLORS, BACKGROUND_COLORS.green, theme.palette.success.dark), _defineProperty(_BANNER_COLORS, BACKGROUND_COLORS.blue, theme.palette.backgrounds.light), _BANNER_COLORS);
  var highestPriority = alerts.length ? alerts.sort(function (a, b) {
    return b.priority - a.priority;
  })[0] : {
    backgroundColor: BACKGROUND_COLORS.green,
    priority: 0
  };
  useEffect(function () {
    if (!visibility.clicked && visibility.display === 'none' && alerts.length && highestPriority.priority > 0) {
      setVisibility({
        display: 'block',
        clicked: false
      });
    }
  });
  return React.createElement(Grid, {
    sx: {
      backgroundColor: BANNER_COLORS[highestPriority.backgroundColor],
      display: visibility.display
    }
  }, React.createElement(Container, null, React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React.createElement(Box, {
    sx: {
      padding: '6px 0',
      maxWidth: '883px',
      width: '100%',
      '& p, h3, span': {
        color: highestPriority.backgroundColor === BACKGROUND_COLORS.green ? 'text.light' : 'text.primary',
        m: 0
      },
      '& span': {
        fontStyle: ASPENDENTAL_FONTS.bodyLargeSemiBold
      }
    }
  }, highestPriority.content && React.createElement(RichText, {
    branding: branding,
    content: highestPriority.content,
    backgroundColor: 'transparent',
    centerAlign: true
  })), React.createElement(Box, {
    sx: {
      color: highestPriority.backgroundColor === BACKGROUND_COLORS.green ? 'text.light' : 'text.link'
    }
  }, React.createElement(TAGSvgIcon, {
    style: {
      cursor: 'pointer',
      transform: 'rotate(45deg)',
      marginLeft: '18px'
    },
    icon: "PlusFunc",
    onClick: function onClick() {
      setVisibility({
        display: 'none',
        clicked: true
      });
    }
  })))));
};

export default AlertBanner;